module.exports = __webpack_public_path__ + "static/media/EULA.6c9d8523.pdf";